import VideoPlayer from '../shared/videoPlayer';
import { setCookie, getCookie } from '../shared/cookieHelper';

const listNLockVideoGenerationTimeout = 300; //in seconds

$(function () {
    if ($('#locknlist_confirmation_page').length) {
        $(document).ready(function () {
            var $loading = $('#ll_loading-div').hide();
            var button = $('#attach-button');
            var input = $('#attach-input');
            var form = new FormData();
            form.append("loan-number", $("#loan-number").val());

            $.ajax({
                url: 'generate-certificate-confirmation',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: form,
                beforeSend: function () {
                },
                success: function (response) {
                    if (response != "") {
                        $("#certlink").attr("href", response.replace(".png", ".pdf"));
                    }
                }
            });

            var loc1 = getCookie("ll_prefix_url");

            $.ajax({
                url: 'generate-flyer-confirmation',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: form,
                beforeSend: function () {
                    $("#openimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                },
                success: function (response) {
                    if (response != "") {
                        $("#openlink").attr("href", response);
                        $("#openimg").attr("src", response.replace(".pdf", ".png"));
                    }
                }
            });

            function PostData(url, data) {
                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#instructions-div p').removeClass('upload-error');
                        $('#instructions-social-div p').removeClass('upload-error');

                        $('[download="CustomVideo"], [download="VideoQRCode"]').parent().addClass('d-none');
                        $('#instructions-div p').text('Please wait while we generate your customized property video. It might take up to 5 minutes');
                        $('#instructions-div').removeClass('d-none');

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').addClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').removeClass('d-none');

                        $('[download="SocialVideo"]').parent().addClass('d-none');
                        $('#instructions-social-div p').text('Please wait while we generate your social video. It might take up to 5 minutes');
                        $('#instructions-social-div').removeClass('d-none');

                        $('#social_video_placeholder, #social_video').addClass('d-none');
                        $('#social_video_loading').removeClass('d-none');

                        $('[download="SocialAdVideo"]').parent().addClass('d-none');
                        $('#instructions-social_ad-div p').text('Please wait while we generate your social video. It might take up to 5 minutes');
                        $('#instructions-social_ad-div').removeClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').addClass('d-none');
                        $('#social_ad_video_loading').removeClass('d-none');

                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            window.location.href = window.location.origin + window.location.pathname + '?id=' + $("#loan-number").val();
                            return;
                        }

                        console.log(result.error);

                        $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                        $('#instructions-social-div p').text('Unable to generate social video.Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');

                        $('#social_video_placeholder, #social_video').removeClass('d-none');
                        $('#social_video_loading').addClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').removeClass('d-none');
                        $('#social_ad_video_loading').addClass('d-none');
                    },
                    error: function (xhr, status, error) {
                        console.log("status: " + status + ' error: ' + error + ' xhr:' + JSON.stringify(xhr));

                        if (xhr.status === 504) {
                            location.reload();
                            return;
                        }

                        $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                        $('#instructions-social-div p').text('Unable to generate social video.Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');

                        $('#social_video_placeholder, #social_video').removeClass('d-none');
                        $('#social_video_loading').addClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').removeClass('d-none');
                        $('#social_ad_video_loading').addClass('d-none');
                    }
                });
            }

            button.on('click', function (e) {
                e.preventDefault();
                input.click();
            });

            $('#attach-input').on('change', function (e) {
                var data = new FormData();
                data.append("loan-number", $("#hdnConfirmationNumber").val());

                var files = e.target.files;
                for (var i = 0; i < files.length; i++) {
                    data.append(files[i].name, files[i]);
                }

                PostData(window.location.origin + window.location.pathname + '/upload-listing-image', data);
            })

            $('#new_sales_price').on('focus', function (e) {
                if ($(this).val() === '$0') {
                    $(this).val('');
                }
            });

            $('#new_sales_price').on('keyup change', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var filteredValue = $(this).val().replace(/\D/g, '');
                if (!filteredValue) {
                    $(this).val('$0');
                    return;
                }

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));
                var newValue = Number(filteredValue);
                $(this).val(newValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));

                if (Math.abs(1 - newValue / curValue) < 0.25) {
                    $('#update_price').prop("disabled", false);
                }
                else
                    console.log('current diff: ' + Math.abs(1 - newValue / curValue));
            });

            $('#new_sales_price').on('blur', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var newValue = Number($('#new_sales_price').val().replace(/\D/g, ''));
                if (newValue == 0)
                    return;

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));

                console.log('price diff: ' + Math.abs(1 - newValue / curValue));
                if (Math.abs(1 - newValue / curValue) > 0.25) {
                    $('#price_error_message').removeClass('d-none');
                    $('#update_price').prop("disabled", true);
                }
                else {
                    $('#price_error_message').addClass('d-none');
                    $('#update_price').prop("disabled", false);
                }
            });

            $('#update_price, #revert_original_price').on('click', function (e) {
                $('#price_change_form').parent().addClass('d-none');
                $('#loading-img-price').removeClass('d-none');

                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_price'
                    ? `update-price?loanNumber=${confirmationNumber}&newPrice=${Number($('#new_sales_price').val().replace(/\D/g, ''))}`
                    : `update-price?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        if (data == 'no data') {
                            $('#update_price_error_message').removeClass('d-none');
                        }
                        if (data == 'no rates') {
                            $('#no_rates_message').removeClass('d-none');
                        }
                        else
                            location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_price_error_message').removeClass('d-none');

                        $('#price_change_form').parent().removeClass('d-none');
                        $('#loading-img-price').addClass('d-none');
                    });
            });

            $('#new_concession').on('keyup change blur', function (e) {
                $('#concession_error_message').addClass('d-none');
                $('#concession_update_error_message').addClass('d-none');

                var value = Number($(this).val());
                if (value >= 1 && value <= 6) {
                    $('#update_seller_concession').prop("disabled", false);
                }
                else {
                    $('#update_seller_concession').prop("disabled", true);
                    $('#concession_error_message').removeClass('d-none');
                }
            });

            $('#revert_seller_concession, #update_seller_concession').on('click', function (e) {
                $('#concession_change_form').parent().addClass('d-none');
                $('#loading-img-seller-concession').removeClass('d-none');

                $('#concession_error_message').addClass('d-none');
                $('#concession_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_seller_concession'
                    ? `update-seller-concession?loanNumber=${confirmationNumber}&newConcession=${Number($('#new_concession').val())}`
                    : `update-seller-concession?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                            location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#concession_update_error_message').removeClass('d-none');

                        $('#concession_change_form').parent().removeClass('d-none');
                        $('#loading-img-seller-concession').addClass('d-none');
                    });
            });

            $('[data-programs] input').on('change', function (e) {
                $('#update_programs').prop('disabled', false);
                $('#update_programs_error_message').removeClass('d-none');
            });

            $('#update_programs').on('click', function (e) {
                $('#loading-img-programs').removeClass('d-none');
                $('#update_programs_error_message').addClass('d-none');
                $('[data-programs]').parent().addClass('d-none');

                var programList = [];
                $('[data-programs] input:checked').each(function () {
                    programList.push($(this).val());
                });

                var confirmation = $('#hdnConfirmationNumber').val();

                var cPathName = location.pathname;
                if (cPathName.indexOf("ll-confirmation") > 0)
                    cPathName = cPathName.replace('ll-confirmation', 'update-program-list?confirmationNumber=');
                else
                    cPathName = cPathName.replace('confirmation', 'update-program-list?confirmationNumber=');

                $.ajax({
                    url: location.origin + cPathName + confirmation,
                    type: 'POST',
                    contentType: 'text/plain',
                    data: programList.join(','),
                    success: function (response) {
                        location.reload();
                    }
                }).done(function (data, textStatus, jqXHR) {
                    location.reload();
                })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_programs_error_message').removeClass('d-none');
                        $('#loading-img-programs').addClass('d-none');
                        $('[data-programs]').parent().removeClass('d-none');
                    });
            });

            if ($('#property_video').is('.pending')) {
                var propertyVideoCounter = 0;

                var cTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=property")
                        .done(function (data, textStatus, jqXHR) {
                            if (data.videoUrl && data.videoUrl.length > 0) {
                                propertyVideoCounter = listNLockVideoGenerationTimeout;

                                $('#property_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                                $('#property_video').removeClass('pending');
                                $('#property_video_loading').addClass('d-none');
                                $('[download="CustomVideo"]').attr('href', data.videoFile);
                                $('[download="CustomVideo"]').parent().removeClass('d-none');
                                new VideoPlayer();

                                $('#property_video_qr').removeClass('d-none');
                                $('#property_video_qr_loading').addClass('d-none');

                                $('[download="VideoQRCode"]').attr('href', data.qrFile);
                                $('[download="VideoQRCode"]').parent().removeClass('d-none');

                                $('#instructions-div').addClass('d-none');
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            propertyVideoCounter = listNLockVideoGenerationTimeout;
                        })
                        .always(function () {
                            propertyVideoCounter++;

                            if (propertyVideoCounter > listNLockVideoGenerationTimeout) {
                                $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                                clearInterval(cTimer);
                            }
                        });
                }, 1000);
            }

            if ($('#social_video').is('.pending')) {
                var socialVideocounter = 0;

                var sTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=social")
                        .done(function (data, textStatus, jqXHR) {
                            if (data.videoUrl && data.videoUrl.length > 0) {
                                socialVideocounter = listNLockVideoGenerationTimeout;

                                $('#social_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#social_video [data-role="play-button"]').attr('href', data.videoUrl);
                                $('#social_video').removeClass('pending');
                                $('#social_video_loading').addClass('d-none');
                                $('[download="SocialVideo"]').attr('href', data.videoFile);
                                $('[download="SocialVideo"]').parent().removeClass('d-none');
                                new VideoPlayer();

                                $('#instructions-social-div').addClass('d-none');
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            socialVideocounter = listNLockVideoGenerationTimeout;
                        })
                        .always(function () {
                            socialVideocounter++;

                            if (socialVideocounter > listNLockVideoGenerationTimeout) {
                                $('#instructions-social-div p').text('Unable to generate social video.Please try again.').addClass('upload-error');
                                clearInterval(sTimer);
                            }
                        });
                }, 1000);
            }

            if ($('#social_ad_video').is('.pending')) {
                var socialAdVideocounter = 0;

                var sTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=social_ad")
                        .done(function (data, textStatus, jqXHR) {
                            if (data.videoUrl && data.videoUrl.length > 0) {
                                socialAdVideocounter = listNLockVideoGenerationTimeout;

                                $('#social_ad_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#social_ad_video [data-role="play-button"]').attr('href', data.videoUrl);
                                $('#social_ad_video').removeClass('pending');
                                $('#social_ad_video_loading').addClass('d-none');
                                $('[download="SocialAdVideo"]').attr('href', data.videoFile);
                                $('[download="SocialAdVideo"]').parent().removeClass('d-none');
                                new VideoPlayer();

                                $('#instructions-social_ad-div').addClass('d-none');
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            socialAdVideocounter = listNLockVideoGenerationTimeout;
                        })
                        .always(function () {
                            socialAdVideocounter++;

                            if (socialAdVideocounter > listNLockVideoGenerationTimeout) {
                                $('#instructions-social_ad-div p').text('Unable to generate social ad video.Please try again.').addClass('upload-error');
                                clearInterval(sTimer);
                            }
                        });
                }, 1000);
            }

            if ($('#reorder_signrider').length) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
                script.async = true;
                document.body.appendChild(script);

                $('[data-toggle="tooltip"]').tooltip();

                $('#reorder_signrider').on('click', function () {
                    $('#signrider_reorder_dialog').addClass('show');
                });

                $('#signrider_newaddress').on('change', function () {
                    $('#signrider_address_form').toggleClass('active');
                    $('.pac-container').css('z-index', '10001');
                });

                $('#cancel_reorder').on('click', function () {
                    $('#address_form_error, #signrider_order_error').addClass('d-none');

                    $('#street_number').val('');
                    $('#route').val('');
                    $('#locality').val('');
                    $('#administrative_area_level_1').val('');
                    $('#postal_code').val('');

                    $('#signrider_reorder_dialog').removeClass('show');

                    $("#signrider_newaddress").prop("checked", false);
                    $('#signrider_address_form').removeClass('active');
                });

                $('#confirm_reorder').on('click', function () {
                    $('#signrider_order_error').addClass('d-none');

                    if ($('#signrider_newaddress').is(':checked')) {
                        var streetNumber = $('#street_number').val();
                        var streetName = $('#route').val();
                        var city = $('#locality').val();
                        var state = $('#administrative_area_level_1').val();
                        var zip = $('#postal_code').val();

                        if (!streetNumber.length || !streetName.length || !city.length || !state.length || !zip.length) {
                            $('#address_form_error').text('Please enter a valid shipping address').removeClass('d-none');
                            return;
                        }
                    }

                    $.post({
                        url: "reorder-sign-rider?confirmation=" + $('#hdnConfirmationNumber').val(),
                        data: { streetNumber, streetName, city, state, zip },
                        beforeSend: function () {
                            $('.dialog-content, .dialog-buttons').addClass('d-none');
                            $('.dialog-loading').removeClass('d-none');
                        }
                    })
                    .done(function () {
                        $('#success_message, #close_reorder').removeClass('d-none');
                        $('#cancel_reorder, #confirm_reorder').addClass('d-none');
                        $('.dialog-content').children().not('#success_message').addClass('d-none');
                    })
                    .fail(function () {
                        $('#address_error').removeClass('d-none');
                        $('#signrider_order_error').removeClass('d-none').children().first().text('Unable to place new sign rider order. Please try again.');
                    })
                    .always(function () {
                        $('.dialog-content, .dialog-buttons').removeClass('d-none');
                        $('.dialog-loading').addClass('d-none');
                    });
                });

                $('#autocomplete').bind("cut copy paste", function (e) {
                    e.preventDefault();
                });

                $('#close_reorder').on('click', function () {
                    $('#signrider_reorder_dialog').removeClass('show');
                    $('#reorder_signrider').parent().addClass('d-none');
                });
            }
        });
    }
});